// extracted by mini-css-extract-plugin
export var actions = "_9-4";
export var brand = "_9-3";
export var header = "_9-0";
export var headerContent = "_9-1";
export var identity = "_9-5";
export var logo = "_9-2";